<template>
  <section class="ege-tutors">
    <div class="v2-container-small">
      <h2
        class="ege-tutors__title"
        v-html="title"
      />

      <div class="ege-tutors__controls">
        <img
          src="/v2/ege/tutors/arrow-left.svg"
          alt="prev"
          @click="prevSlide"
        >
        <img
          src="/v2/ege/tutors/arrow-right.svg"
          alt="next"
          @click="nextSlide"
        >
      </div>
    </div>

    <div class="ege-tutors__slider">
      <custom-scroll-slider
        ref="slider"
        class="ege-tutors__slider--inner"
        :items="citiesList"
        :container-width="1240"
        :gap="isTablet ? 8 : 20"
        by-step
        @updateSlideNumber="slideNumber = $event"
      >
        <template #item="{ slide }">
          <div class="card">
            <div class="card__inner">
              <img
                :src="slide.image"
                :alt="slide.address"
                class="card__image"
              >

              <p class="card__title">
                Филиал на {{ slide.address }}:
              </p>

              <ul class="card__list">
                <li>
                  <img
                    src="/v2/ege/tutors/dot.svg"
                    alt="dot"
                  >
                  <span>Адрес филиала: {{ slide.address }}</span>
                </li>
                <li>
                  <img
                    src="/v2/ege/tutors/dot.svg"
                    alt="dot"
                  >
                  <span>Формат обучения: Индивидуально, в группе</span>
                </li>
              </ul>

              <button
                class="card__btn"
                @click="$emit('openModal', slide.address)"
              >
                <img
                  src="/v2/ege/tutors/arrow.svg"
                  alt="arrow"
                >
                <span>Хочу учиться здесь</span>
              </button>

              <div
                class="card__bg"
                :style="`background-color: ${slide.bgColor}`"
              />
            </div>
          </div>
        </template>
      </custom-scroll-slider>
    </div>
  </section>
</template>

<script>
import CustomScrollSlider from '~/components/v2/common/CustomScrollSlider.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'EgeCity',
  components: {
    CustomScrollSlider,
  },

  data: () => ({
    slideNumber: 1,
  }),
  computed: {
    ...mapGetters({
      isTablet: 'isTablet',
    }),

    title() {
      switch (this.$route.name) {
        case 'ege-moscow':
          return '12 филиалов <br><span><span>в Москве и МО</span></span>';
        case 'ege-chelyabinsk':
          return '2 филиала <br><span><span>в Челябинске</span></span>';
        case 'ege-kazan':
          return '3 филиала <br><span><span>в Казани</span></span>';
        case 'ege-krasnoyarsk':
          return '1 филиал <br><span><span>в Красноярске</span></span>';
        case 'ege-nizhny-novgorod':
          return '1 филиал <br><span><span>в Нижнем Новгороде</span></span>';
        case 'ege-novosibirsk':
          return '2 филиала <br><span><span>в Новосибирске</span></span>';
        case 'ege-saint-petersburg':
          return '2 филиала <br><span><span>в Санкт-Петербурге</span></span>';
        case 'ege-samara':
          return '2 филиала <br><span><span>в Самаре</span></span>';
        case 'ege-ufa':
          return '1 филиал <br><span><span>в Уфе</span></span>';
        case 'ege-yekaterinburg':
          return '1 филиал <br><span><span>в Екатеринбурге</span></span>';
        default:
          return 'Филиалы';
      }
    },

    citiesList() {
      const moscow = [
        {
          id: 1,
          address: 'Тверская ул., 4',
          image: '/v2/ege/cities/москва/Тверская улица.webp',
          bgColor: '#FBBD1E',
        },
        {
          id: 2,
          address: 'Измайловский Вал, 2',
          image: '/v2/ege/cities/москва/Измайловский Вал, 2.webp',
          bgColor: '#A8FF53',
        },
        {
          id: 3,
          address: 'Хлебозаводский пр., 7, стр. 10',
          image: '/v2/ege/cities/москва/Хлебозаводский пр., 7, стр. 10.webp',
          bgColor: '#2FF9BC',
        },
        {
          id: 4,
          address: 'Смольная ул., 10',
          image: '/v2/ege/cities/москва/Смольная ул., 10.webp',
          bgColor: '#67ADFF',
        },
        {
          id: 5,
          address: 'Мещанская ул., 9/14с1',
          image: '/v2/ege/cities/москва/Мещанская ул., 9 14с1.webp',
          bgColor: '#FF7233',
        },
        {
          id: 6,
          address: 'Новинский бул., 31',
          image: '/v2/ege/cities/москва/Ленинградский просп., 80Г.webp',
          bgColor: '#EFBD99',
        },
        {
          id: 7,
          address: 'Красногорск. Дачная ул., 11А,',
          image: '/v2/ege/cities/москва/Красногорск. Дачная ул., 11А.webp',
          bgColor: '#FE9CE0',
        },
        {
          id: 8,
          address: 'поселение Московский, Киевское шоссе, 22-й километр, 4',
          image: '/v2/ege/cities/москва/поселение Московский, Киевское шоссе, 22-й километр, 4.webp',
          bgColor: '#A8FF53',
        },
        {
          id: 9,
          address: 'Ленинградский просп., 80Г',
          image: '/v2/ege/cities/москва/Ленинградский просп., 80Г.webp',
          bgColor: '#67ADFF',
        },
        {
          id: 10,
          address: 'Партизанская ул., 27',
          image: '/v2/ege/cities/москва/Партизанская ул., 27.webp',
          bgColor: '#FF5151',
        },
        {
          id: 11,
          address: 'Одинцово. Можайское ш., 55',
          image: '/v2/ege/cities/москва/Одинцово. Можайское ш., 55.webp',
          bgColor: '#FF7233',
        },
        {
          id: 12,
          address: 'Усиевича ул, 20, корп. 1',
          image: '/v2/ege/cities/москва/Усиевича ул, 20, корп. 1.webp',
          bgColor: '#EFBD99',
        },
      ];

      const saintPetersburg = [
        {
          id: 1,
          address: 'Лодейнопольская ул., 5',
          image: '/v2/ege/cities/петербург/Лодейнопольская ул., 5.webp',
          bgColor: '#FBBD1E',
        },
        {
          id: 2,
          address: 'Московский просп., 107, корп. 4',
          image: '/v2/ege/cities/петербург/Московский просп., 107, корп. 4.webp',
          bgColor: '#A8FF53',
        },
      ];

      const novosibirsk = [
        {
          id: 1,
          address: 'ул. Революции, 38',
          image: '/v2/ege/cities/новосибирск/ул. Революции, 38.webp',
          bgColor: '#2FF9BC',
        },
        {
          id: 2,
          address: 'ул. Никитина, 20',
          image: '/v2/ege/cities/новосибирск/ул. Никитина, 20.webp',
          bgColor: '#67ADFF',
        },
      ];

      const yekaterinburg = [
        {
          id: 1,
          address: 'ул. Карла Либкнехта, 22',
          image: '/v2/ege/cities/екатеринбург/ул. Карла Либкнехта, 22.webp',
          bgColor: '#FF7233',
        },
      ];

      const kazan = [
        {
          id: 1,
          address: 'Петербургская ул., 74',
          image: '/v2/ege/cities/казань/Петербургская ул., 74.webp',
          bgColor: '#EFBD99',
        },
        {
          id: 2,
          address: 'ул. Четаева, 4',
          image: '/v2/ege/cities/казань/ул. Четаева, 4.webp',
          bgColor: '#FE9CE0',
        },
        {
          id: 3,
          address: 'ул. Галиаскара Камала, 41',
          image: '/v2/ege/cities/казань/ул. Галиаскара Камала, 41.webp',
          bgColor: '#A8FF53',
        },
      ];

      const krasnoyarsk = [
        {
          id: 1,
          address: 'ул. 9 Мая, 83, корп. 2',
          image: '/v2/ege/cities/красноярск/ул. 9 Мая, 83, корп. 2.webp',
          bgColor: '#67ADFF',
        },
      ];

      const nizhnyNovgorod = [
        {
          id: 1,
          address: 'ул. Максима Горького, 260',
          image: '/v2/ege/cities/нижний новгород/Максима Горького, 260.webp',
          bgColor: '#FF5151',
        },
      ];

      const chelyabinsk = [
        {
          id: 1,
          address: 'площадь Революции, 7А',
          image: '/v2/ege/cities/челябинск/площадь Революции, 7А.webp',
          bgColor: '#FF7233',
        },
        {
          id: 2,
          address: 'просп. Ленина, 55А',
          image: '/v2/ege/cities/челябинск/просп. Ленина, 55А.webp',
          bgColor: '#EFBD99',
        },
      ];

      const ufa = [
        {
          id: 1,
          address: 'ул. Ветошникова, 99',
          image: '/v2/ege/cities/уфа/ул. Ветошникова, 99.webp',
          bgColor: '#FBBD1E',
        },
      ];

      const samara = [
        {
          id: 1,
          address: 'Московское ш., 41',
          image: '/v2/ege/cities/самара/Московское ш., 41.webp',
          bgColor: '#A8FF53',
        },
        {
          id: 2,
          address: 'пр. Георгия Митирёва, 11',
          image: '/v2/ege/cities/самара/пр. Георгия Митирёва, 11.webp',
          bgColor: '#2FF9BC',
        },
      ];

      switch (this.$route.name) {
        case 'ege-moscow': return moscow;
        case 'ege-chelyabinsk': return chelyabinsk;
        case 'ege-kazan': return kazan;
        case 'ege-krasnoyarsk': return krasnoyarsk;
        case 'ege-nizhny-novgorod': return nizhnyNovgorod;
        case 'ege-novosibirsk': return novosibirsk;
        case 'ege-saint-petersburg': return saintPetersburg;
        case 'ege-samara': return samara;
        case 'ege-ufa': return ufa;
        case 'ege-yekaterinburg': return yekaterinburg;
        default: return [];
      }
    },
  },

  methods: {
    nextSlide() {
      this.$refs.slider.nextSlide();
    },
    prevSlide() {
      this.$refs.slider.prevSlide();
    },
  },
};
</script>

<style lang="scss" scoped>
.ege-tutors {
  margin-bottom: -60px;

  &__title {
    font-size: 45px;
    font-weight: 700;
    line-height: 111%;
    letter-spacing: -0.03em;
    color: $black-color;
    text-transform: uppercase;
    position: relative;
    z-index: 1;

    @include media-down(tablet) {
      padding: 0 8px;
      font-size: 24px;
      font-weight: 800;
    }

    ::v-deep & > span {
      display: inline-block;
      position: relative;

      &:before {
        content: '';
        width: 102%;
        height: 98%;
        background-color: $ege-orange;
        box-shadow: 0 2px 35px 0 rgba($blue-darkest, .2);
        position: absolute;
        left: -1%;
        bottom: -2%;
      }

      span {
        position: relative;
        z-index: 2;
        color: $white-color;
      }
    }
  }

  &__controls {
    position: absolute;
    right: 10px;
    top: 54px;
    display: flex;
    gap: 10px;
    z-index: 1;

    @include media-down(tablet) {
      display: none;
    }

    img {
      cursor: pointer;
    }
  }

  &__slider {
    margin-top: 10px;
    position: relative;
    z-index: 1;
  }

  .card {
    width: 420px;
    padding-top: 50px;
    padding-bottom: 60px;

    @include media-down(tablet) {
      width: 296px;
      padding-top: 22px;
    }

    &__inner {
      position: relative;
      width: 100%;
      padding: 20px;
      overflow: hidden;

      border-radius: 20px;
      background-color: $white-color;
      box-shadow: 4px 4px 20px 0 rgba($ege-blue-darkest, .05), 10px 10px 50px 0 rgba($ege-blue-darkest, .1);

      @include media-down(tablet) {
        padding: 8px;
      }
    }

    &__image {
      width: 100%;
      height: 253px;
      object-fit: cover;

      @include media-down(tablet) {
        height: 180px;
      }
    }

    &__title {
      margin-top: 20px;

      font-size: 24px;
      font-weight: 500;
      line-height: 130%;
      color: $black-color;

      @include media-down(tablet) {
        margin-top: 8px;
        padding: 0 8px;

        font-size: 18px;
        line-height: 122%;
      }
    }

    &__list {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      gap: 12px;

      @include media-down(tablet) {
        margin-top: 12px;
        padding: 0 8px;
        gap: 8px;
      }

      li {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;

        font-size: 16px;
        font-weight: 500;
        line-height: 130%;
        letter-spacing: -0.01em;
        color: $black-color;

        @include media-down(tablet) {
          font-size: 14px;
        }

        img {
          margin-right: 8px;
          margin-top: 4px;
        }
      }
    }

    &__btn {
      position: relative;
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 40px;
      padding: 0;

      background-color: transparent;
      border: none;

      font-family: 'TildaSans', sans-serif;
      font-size: 20px;
      font-weight: 700;
      line-height: 120%;
      color: $black-color;

      cursor: pointer;

      @include media-down(tablet) {
        margin-top: 36px;
        margin-bottom: 12px;
        padding: 0 8px;
        gap: 5px;
        font-size: 18px;
        line-height: 100%;
        font-weight: 600;
      }

      img {
        @include media-down(tablet) {
          width: 12px;
        }
      }

      &::after {
        content: '';
        display: block;
        height: 2px;
        width: 0;
        position: absolute;
        left: 0;
        bottom: 0;
        background-color: $black-color;

        transition: width .2s ease-out;
      }

      &:hover {
        &::after {
          width: 100%;
        }
      }
    }

    &__bg {
      position: absolute;
      right: -70px;
      bottom: -70px;
      width: 140px;
      height: 140px;

      border-radius: 70px;
      filter: blur(100px);
    }
  }
}
</style>
